import React from 'react';
import { StyledComponentWrapper, StyledGalleryWrapper } from './testimonial-slider.style';
import { SimpleGallery } from '../../atoms/simple-gallery/simple-gallery';
import { theme } from '../../../style/global-style';
import { Testimonial, ITestimonial } from './testimonial';

interface ITestimonialSlider {
    testimonials: ITestimonial[];
}

export const TestimonialSlider = ({ testimonials }: ITestimonialSlider) => {
    return (
        <StyledComponentWrapper>
            <StyledGalleryWrapper>
                <SimpleGallery
                    arrowColor={theme.colors.main4}
                    showDots={false}
                    showFadedArrow={true}
                >
                    {testimonials.map(item => (
                        <Testimonial
                            key={item.name + item.time}
                            quote={item.quote}
                            name={item.name}
                            additionalInfo={item.additionalInfo}
                        />
                    ))}
                </SimpleGallery>
            </StyledGalleryWrapper>
        </StyledComponentWrapper>
    );
};
